import { podoFetcher } from '@server/infrastructure/external-apis/podo/client'
import { rpc } from '@server/infrastructure/rpc'
import { RegisterCardReq } from '@server/schemas'

import { updatePaymentMethod } from './payment-methods.api'

export const paymentMethodsEntityMutations = {
  registerCard: ({ bearerToken }: RequestQueryOptions) => ({
    mutationKey: ['registerCard'],
    mutationFn: async (dto: RegisterCardReq) => {
      const response = await rpc.api.v1['payment-methods'].card.$post(
        { json: dto },
        {
          headers: {
            Authorization: `Bearer ${bearerToken}`,
          },
        },
      )

      if (!response.ok) {
        const error = await response.json()

        throw new Error(error.cause.data.message, {
          cause: error.cause.data.resultCdName,
        })
      }

      return await response.json()
    },
  }),
  updatePaymentMethod: ({ bearerToken }: RequestQueryOptions) => ({
    mutationKey: ['updatePaymentMethod'],
    mutationFn: async (cardId: string) => await updatePaymentMethod(bearerToken, cardId),
  }),

  deletePaymentMethod: ({ bearerToken }: RequestQueryOptions) => ({
    mutationKey: ['deletePaymentMethod'],
    mutationFn: async (cardId: string) => {
      return await podoFetcher({
        url: `/api/v1/card/delete?cardId=${cardId}`,
        method: 'DELETE',
        header: {
          Authorization: `Bearer ${bearerToken}`,
        },
      })
    },
  }),
}
